var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 2.0968H3.99375C2.89375 2.0968 2 3.00305 2 4.11555V28.0781C2 29.1906 2.89375 30.0968 3.99375 30.0968H28C29.1 30.0968 30 29.1906 30 28.0781V4.11555C30 3.00305 29.1 2.0968 28 2.0968ZM10.4625 26.0968H6.3125V12.7343H10.4688V26.0968H10.4625ZM8.3875 10.9093C7.05625 10.9093 5.98125 9.82805 5.98125 8.50305C5.98125 7.17805 7.05625 6.0968 8.3875 6.0968C9.7125 6.0968 10.7937 7.17805 10.7937 8.50305C10.7937 9.8343 9.71875 10.9093 8.3875 10.9093ZM26.0187 26.0968H21.8687V19.5968C21.8687 18.0468 21.8375 16.0531 19.7125 16.0531C17.55 16.0531 17.2188 17.7406 17.2188 19.4843V26.0968H13.0688V12.7343H17.05V14.5593H17.1062C17.6625 13.5093 19.0188 12.4031 21.0375 12.4031C25.2375 12.4031 26.0187 15.1718 26.0187 18.7718V26.0968Z",
    fill: "#E72E50"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.c2bb7676983b20e87a95de7e288fc16f.svg";
export { ForwardRef as ReactComponent };